<template>
  <section class='content'>
    <div class="modal fade" id="queryModal" tabindex="-1" role="dialog" aria-labelledby="queryModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title" id="forgot_ModalLabel"><i class="fa fa-database mr-5"></i>SQL</h4>
          </div>
          <div class="modal-body text-center">
            <p>{{query}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="payloadModal" ref="payloadModal" tabindex="-1" role="dialog" aria-labelledby="payloadModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Information</h4>
          </div>
          <div class="modal-body">
            <p v-if="information.payload"><strong>Payload:</strong><br/> <pre>{{information.payload}}</pre></p>
            <p><strong>Result:</strong><br/><pre>{{information.message}}</pre></p>
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <button v-if="information.status.text === 'text-danger'" class="btn btn-info mr-5" @click="retryEvent(information)"><i class="fa fa-refresh"></i> {{'retry'|translate}}</button>
              <button v-if="information.status.text === 'text-danger'" class="btn btn-danger" @click="showCancelConfirmModal(information)"><i class="fa fa-ban"></i> {{'delete'|translate}}</button>
            </div>
            <div>
              <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <monitoring :type="'events'" @pop="selectEvent($event)" :reload="reload" @update="" modifier="erp" ref="monitoring"></monitoring>
    </div>
  </section>
</template>
<script>
  import MonitoringComponent from '../../tools/MonitoringComponent.vue'
  import MonitoringTableComponent from '../../tools/Tables/MonitoringTableComponent.vue'

  export default {
    data () {
      return {
        orders: {},
        reload: [],
        language: this.$store.getters.language,
        cancelReason: 'out_of_stock',
        lineForCancel: 0,
        query: '',
        alerts: [],
        information: {
          message: {
          },
          payload: {
          },
          status: {
          }
        }
      }
    },
    components: {
      monitoring: MonitoringComponent,
      monitoringTable: MonitoringTableComponent
    },
    methods: {
      update (value) {
        this.query = value
      },
      notify (value) {
        this.$store.commit('pushAlert', {dismiss: 4, type: value[0], message: value[1], icon: value[2], show: true})
      },
      selectEvent (value) {
        this.information = ''
        this.information = value
      },
      retryEvent(item) {
        this.$refs.monitoring.retryEvent(item);
      },
      showCancelConfirmModal(item) {
        $(this.$refs.payloadModal).modal('hide');
        this.$refs.monitoring.showCancelConfirmModal(item);
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/Monitoring/ErpWorker.vue